// extracted by mini-css-extract-plugin
module.exports = {"brandingsNew":"_1hkRj","brandingLogo":"_3RS1B","upgrade":"zRrqE"};